import React, { Fragment } from 'react';
import { Iconfont as IconFont } from '@umu/umu-design';
import { IProps, IListProps } from '../../theme/interface/common';
import { CertificateTheme } from '../certificateTheme';

const CertificateThemeList = (props: IListProps) => {
    const {
        list = [],
        footerContent = '',
        className = '',
        isRadioSelect = false,
        selectList = [],
        onClick,
        onChangeList,
    } = props;

    const onDelItem = (e: React.SyntheticEvent, index: number) => {
        if (onChangeList) {
            list.splice(index, 1);
            onChangeList(list);
        }
        e.stopPropagation();
    };
    const renderThemeList = () => {
        return list.map((_: IProps, index: number) => {
            let selectElement: JSX.Element | string = '';
            let delElement: JSX.Element | string = '';
            if (isRadioSelect) {
                const isSelect = selectList.indexOf(index) !== -1;
                selectElement = isSelect ? (
                    <IconFont type="Complete" className="radio-theme-select" />
                ) : (
                    <div className="radio-theme-select radio-theme" />
                );
            }
            if (_.isAllowDelete) {
                _.isShowMask = true;
                delElement = <IconFont type="Trash" className="del-theme-info" onClick={(e) => onDelItem(e, index)} />;
            }
            if (isRadioSelect || _.isAllowDelete) {
                _.isShowMask = true;
                _.customMask = (
                    <Fragment>
                        {selectElement}
                        {delElement}
                    </Fragment>
                );
            }
            return (
                <li
                    key={`theme-card-info-${index}`}
                    className={`theme-item-card ${isRadioSelect && selectList.indexOf(index) !== -1 ? 'theme-item-card-select' : ''} ${_.className || ''}`}
                    onClick={() => onClick && onClick(index, _)}
                >
                    <div className="theme-item">
                        <CertificateTheme {..._} onConfigChange={(key, val) => {
                            props.onConfigChange && props.onConfigChange(index, key, val)
                        }}/>
                    </div>
                </li>
            );
        });
    };
    return (
        <ul className={`certificate-theme-list ${className}`}>
            {renderThemeList()}
            {footerContent}
        </ul>
    );
};

export {
    CertificateThemeList,
}
